import { Component } from '@angular/core';
import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-input',
  templateUrl: './formly-input.component.html',
  styleUrl: './formly-input.component.scss',
})
export class FormlyInputComponent extends FormlyFieldBaseComponent {
  get type() {
    return this.props.type ?? 'text';
  }

  keyUpEnter(event: any) {
    if (this.props.enter) {
      this.props.enter(event);
    }
  }

  keyUpBackspace(event: any) {
    if (this.props.backspaceReset) {
      this.clear();
    }
    if (this.props.backspace) {
      this.props.backspace(event);
    }
  }
  onClick(event) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  onFocus() {
    if (this.props.focusReset) {
      this.clear();
    }
  }

  private clear() {
    this.form.patchValue({ [this.key]: undefined } as any);
  }
}
